import { useMemo } from "react";
import { matches } from "@/mocks/matches";
import { teams } from "@/mocks/teams";
import { news } from "@/mocks/news";

export type SearchItem = {
  key: string;
  label: string;
  sub: string;
  to: string;
  type: string;
};

export function useSiteSearch(query: string): SearchItem[] {
  return useMemo<SearchItem[]>(() => {
    const q = query.trim().toLowerCase();
    if (!q) return [];
    const matchHits: SearchItem[] = matches
      .filter(
        (m) =>
          m.home.name.toLowerCase().includes(q) ||
          m.away.name.toLowerCase().includes(q) ||
          m.home.shortName.toLowerCase().includes(q) ||
          m.away.shortName.toLowerCase().includes(q) ||
          m.leagueName.toLowerCase().includes(q)
      )
      .slice(0, 4)
      .map((m) => ({
        key: m.id,
        label: `${m.home.shortName} vs ${m.away.shortName}`,
        sub: `${m.leagueName} · ${m.date}`,
        to: `/match/${m.id}`,
        type: "比赛",
      }));
    const teamHits: SearchItem[] = teams
      .filter((t) => t.name.toLowerCase().includes(q) || t.shortName.toLowerCase().includes(q))
      .slice(0, 3)
      .map((t) => ({
        key: t.id,
        label: t.name,
        sub: `${t.city} · ${t.leagueSlug.toUpperCase()}`,
        to: `/category/${t.leagueSlug}`,
        type: "球队",
      }));
    const newsHits: SearchItem[] = news
      .filter((n) => n.title.toLowerCase().includes(q) || n.summary.toLowerCase().includes(q))
      .slice(0, 4)
      .map((n) => ({
        key: n.id,
        label: n.title,
        sub: n.category,
        to: `/news/${n.id}`,
        type: "资讯",
      }));
    return [...matchHits, ...teamHits, ...newsHits];
  }, [query]);
}

export default useSiteSearch;